<template>
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.2608 0.677734C5.31322 0.677734 0.491592 5.49928 0.491592 11.447C0.491592 17.3947 5.31322 22.2162 11.2608 22.2162C17.2084 22.2162 22.0301 17.3947 22.0301 11.447C22.0301 5.49928 17.2084 0.677734 11.2608 0.677734ZM14.9829 12.0178L9.59832 15.3832C9.48937 15.4512 9.36548 15.4854 9.24159 15.4854C9.12936 15.4854 9.01695 15.4575 8.91524 15.401C8.70128 15.2823 8.56852 15.0572 8.56852 14.8124V8.08158C8.56852 7.83675 8.70128 7.6116 8.91524 7.49297C9.12919 7.37367 9.39081 7.38091 9.59832 7.51073L14.9829 10.8761C15.1796 10.9994 15.2993 11.215 15.2993 11.447C15.2993 11.679 15.1796 11.8946 14.9829 12.0178Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Play',
};
</script>
